/**
 * Thời gian tối thiểu từ lúc task **bắt đầu** tới lúc được chuyển sang Xong —
 * APM-TMIN, người dùng chốt 2026-10-12: "không để việc vừa tạo ra đã hoàn thành".
 *
 * - Cấu hình theo dự án (`project.min_task_duration_minutes`), `null` = tắt.
 * - Mốc bắt đầu = `actualStartAt` (lần đầu vào cột "đang làm", hoặc mốc người
 *   dùng **khai tay**), chưa có thì lúc tạo việc.
 * - Áp cho mọi người bấm, kể cả PM. Lệnh hệ thống (đồng bộ, luật git, demo) đi qua.
 * - Mốc (milestone) không áp: nó là một thời điểm, không có thời lượng.
 * - Người quên chuyển sang "đang làm" lúc bắt đầu thì **khai lại** giờ bắt đầu
 *   thực tế ngay trong lần chuyển sang Xong — không tương lai, lùi tối đa
 *   `MAX_DECLARED_START_DAYS` ngày, và mốc ấy mang cờ `actualStartDeclared`.
 *
 * Hàm thuần, web và API cùng dùng — giao diện mở hộp thoại trước khi gọi API,
 * còn cửa thật ở `ChangeTaskStatusHandler` / `UpdateProgressHandler`.
 */
/** Trần của cấu hình: 30 ngày tính bằng phút — vừa `SMALLINT UNSIGNED`. */
export const MAX_MIN_TASK_DURATION_MINUTES = 30 * 24 * 60;
/** Khai lại giờ bắt đầu được lùi tối đa bao nhiêu ngày so với lúc khai. */
export const MAX_DECLARED_START_DAYS = 30;
/**
 * Đồng hồ máy người dùng có thể nhanh hơn server vài giây. Một mốc "vừa bấm
 * xong" không được bị từ chối là "ở tương lai" chỉ vì lệch đồng hồ.
 */
const FUTURE_SKEW_MS = 2 * 60 * 1000;
const MINUTE_MS = 60 * 1000;
/**
 * Sớm nhất lúc nào việc này được chuyển sang Xong. `null` = không giới hạn
 * (dự án tắt cấu hình, hoặc việc là mốc).
 */
export function completableAt(input) {
    if (!input.minMinutes || input.minMinutes <= 0)
        return null;
    if (input.kind === 'milestone')
        return null;
    const start = input.actualStartAt ?? input.createdAt;
    return new Date(start.getTime() + input.minMinutes * MINUTE_MS);
}
/**
 * `null` = được hoàn thành lúc `now`; còn lại là số phút còn thiếu (làm tròn
 * lên, ≥ 1) và mốc sớm nhất.
 */
export function completionTooSoon(input, now) {
    const earliestAt = completableAt(input);
    if (earliestAt === null || earliestAt.getTime() <= now.getTime())
        return null;
    return {
        earliestAt,
        remainingMinutes: Math.max(1, Math.ceil((earliestAt.getTime() - now.getTime()) / MINUTE_MS)),
    };
}
/** Lỗi của một mốc bắt đầu khai tay, hoặc `null` nếu hợp lệ. */
export function declaredStartProblem(at, now) {
    if (at.getTime() > now.getTime() + FUTURE_SKEW_MS)
        return 'future';
    if (at.getTime() < now.getTime() - MAX_DECLARED_START_DAYS * 24 * 60 * MINUTE_MS) {
        return 'too_old';
    }
    return null;
}
//# sourceMappingURL=task-min-duration.js.map